import { render, staticRenderFns } from "./EditMyData.vue?vue&type=template&id=bec65b96"
import script from "./EditMyData.vue?vue&type=script&lang=js"
export * from "./EditMyData.vue?vue&type=script&lang=js"
import style0 from "./EditMyData.vue?vue&type=style&index=0&id=bec65b96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports